import FileSystemCache from './cache';
export default (options) => new FileSystemCache(options);
